import { render } from "./informList.vue?vue&type=template&id=14244008"
import script from "./informList.vue?vue&type=script&lang=js"
export * from "./informList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__